import { render, staticRenderFns } from "./ReservationsDashboard.vue?vue&type=template&id=6e477482"
import script from "./ReservationsDashboard.vue?vue&type=script&lang=js"
export * from "./ReservationsDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports